import React from 'react';
import './project-app-timeline-block.scss';

interface TimelineLink {
  label: string;
  url: string;
}

interface TimelineEvent {
  time?: string;
  subtitle?: string;
  icon?: string;
  image?: string;
  title: string;
  description?: string;
  links?: TimelineLink[];
}

interface TimelineGroup {
  label: string;
  events: TimelineEvent[];
}

interface ProjectAppTimelineBlockProps {
  data: Record<string, unknown>;
}

const ProjectAppTimelineBlock: React.FC<ProjectAppTimelineBlockProps> = ({
  data,
}) => {
  const groups = (data.groups as TimelineGroup[] | undefined) || [];

  if (groups.length === 0) {
    return (
      <div className='project-app-timeline-block'>
        <p className='timeline-empty'>No events to display.</p>
      </div>
    );
  }

  return (
    <div className='project-app-timeline-block'>
      {groups.map((group, gi) => (
        <div key={gi} className='timeline-day'>
          <div className='timeline-day__header'>{group.label}</div>
          <div className='timeline-day__events'>
            {group.events.map((evt, ei) => {
              const isLast = ei === group.events.length - 1;
              return (
                <div
                  key={ei}
                  className={`timeline-event${isLast ? ' timeline-event--last' : ''}`}
                >
                  <div className='timeline-event__left'>
                    {evt.time && (
                      <span className='timeline-event__time'>{evt.time}</span>
                    )}
                    {evt.subtitle && (
                      <span className='timeline-event__tz'>{evt.subtitle}</span>
                    )}
                  </div>
                  <div className='timeline-event__line'>
                    {evt.icon ? (
                      <div className='timeline-event__icon'>{evt.icon}</div>
                    ) : (
                      <div className='timeline-event__dot' />
                    )}
                    {!isLast && <div className='timeline-event__connector' />}
                  </div>
                  <div className='timeline-event__content'>
                    {evt.image && (
                      <img
                        className='timeline-event__image'
                        src={evt.image}
                        alt={evt.title}
                      />
                    )}
                    <div className='timeline-event__title'>{evt.title}</div>
                    {evt.description && (
                      <div className='timeline-event__desc'>
                        {evt.description}
                      </div>
                    )}
                    {evt.links && evt.links.length > 0 && (
                      <div className='timeline-event__links'>
                        {evt.links.map((link, li) => (
                          <a
                            key={li}
                            className='timeline-event__link'
                            href={link.url}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            {link.label}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectAppTimelineBlock;
